<template>
  <view-wrapper
    name="Web hooks"
    :loading="loading"
    :loadingText="loadingText"
    :saveFunc="saveWebHooksConfig"
    saveText="Save"
  >
    <wrapper class="mb-5" :check-for-child-focused="true">
      <div v-if="webhooks" class="mb-8">
        <div
          v-for="(data, index) in webhooks"
          :key="`editable-article-data-${index}`"
          class="relative flex my-2"
        >
          <grafokett-input
            :id="`editable-key-${index}`"
            type="text"
            label-placeholder="Type"
            v-model="data.webHookType"
            class="mx-2 edit"
            disabled
          />
          <grafokett-input
            :id="`editable-data-${index}`"
            :type="data.propertyType"
            label-placeholder="Url"
            v-model="data.webHookUrl"
            :editable="data.editable"
            :maxlength="4000"
          />
        </div>
      </div>
    </wrapper>
  </view-wrapper>
</template>

<script>
import GrafokettInput from "../components/forms/Input";
import ViewWrapper from "../components/ViewWrapper.vue";
import Wrapper from "../components/Wrapper.vue";

export default {
  components: {
    ViewWrapper,
    Wrapper,
    GrafokettInput,
  },
  data() {
    return {
      loading: false,
      loadingText: "Loading Web Hooks",
      webhooks: [],
      headers: {
        webHookType: "Type",
        webHookUrl: "URL",
      },
      agentToRelease: null,
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      const { data } = await this.$store.$api.get(
        "/api/IntegrationWebHooks/WebHookConfig"
      );
      this.webhooks = data && data.data;
      this.loading = false;
    },
    async saveWebHooksConfig() {
      for (var webhook of this.webhooks) {
        await this.$store.$api.post(
          "/api/IntegrationWebHooks/WebHookConfig",
          webhook
        );
      }
      await this.getData();
    },
  },
  beforeMount() {
    this.getData();
  },
};
</script>
